export { Roles, type Role, RoleLabels, normalizeRole, isSuperAdmin, isAdmin, isOperator, isAdminLike } from "../auth/roles";
import { Roles } from "../auth/roles";

export const RoleGroups = {
    superAdminAndAdmin: [Roles.superAdmin, Roles.admin],
    superAdminOnly: [Roles.superAdmin],
    adminOnly: [Roles.admin],
    operatorOnly: [Roles.operator],
    allRoles: [Roles.superAdmin, Roles.admin, Roles.operator]
}
